// extracted by mini-css-extract-plugin
module.exports = {"position-name":"Positions_position-name__6I0yH","num":"Positions_num__2kJhq"};